export default __webpack_public_path__ + "static/media/ecom3.4474de73.png";